module.exports = __webpack_public_path__ + "media/images/icons/mp-logo-black-32241961829433e774bf108e5d780db7.svg";